import { COURT_DIMENSIONS } from "./courtConstants";

// Helper to convert court coordinates to world coordinates
export function courtToWorld(courtX, courtY) {
	return {
		x: courtX - COURT_DIMENSIONS.WIDTH / 2,
		z: courtY - COURT_DIMENSIONS.HEIGHT / 2,
	};
}

export const PIXEL_COURT_WIDTH = 919;
const PIXEL_COURT_HEIGHT = 492;

export function pixelToCourt(pixelX, pixelY, left_or_right) {
	if (left_or_right === "left" || pixelX < PIXEL_COURT_WIDTH / 2) {
		return {
			y: (pixelX / (PIXEL_COURT_WIDTH / 2)) * COURT_DIMENSIONS.HEIGHT,
			x:
				COURT_DIMENSIONS.WIDTH -
				(pixelY / PIXEL_COURT_HEIGHT) * COURT_DIMENSIONS.WIDTH,
		};
	} else if (left_or_right === "right" || pixelX > PIXEL_COURT_WIDTH / 2) {
		return {
			y:
				((PIXEL_COURT_WIDTH - pixelX) / (PIXEL_COURT_WIDTH / 2)) *
				COURT_DIMENSIONS.HEIGHT,
			x: (pixelY / PIXEL_COURT_HEIGHT) * COURT_DIMENSIONS.WIDTH,
		};
	}
}

/**
 * Ensures a shot location is in world space format
 * Provides backwards compatibility during migration
 *
 * @param {Object} location - Shot location (either old court space or new world space)
 * @returns {{x: number, y: number, z: number}} Location in world space
 */
export function normalizeToWorldSpace(location) {
	if (!location) return { x: 0, y: 0, z: 0 };

	// Check if already in world space (has z property)
	if (location.z !== undefined) {
		return location; // Already in world space
	}

	// Old format: {x, y} in court space - convert to world space
	// Court space: x: [0, 14], y: [0, 15], origin at corner
	// World space: x: [-7, +7], y: 0, z: [-7.5, +7.5], origin at center
	return {
		x: location.x - COURT_DIMENSIONS.WIDTH / 2,
		y: 0,
		z: location.y - COURT_DIMENSIONS.HEIGHT / 2,
	};
}

export const isPointInPolygon = (point, polygon) => {
	let inside = false;
	for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
		const xi = polygon[i].x,
			yi = polygon[i].y;
		const xj = polygon[j].x,
			yj = polygon[j].y;

		const intersect =
			yi > point.y !== yj > point.y &&
			point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;
		if (intersect) inside = !inside;
	}
	return inside;
};
